import { AdminInput, AdminToggle, AdminSelect, AdminSectionCard } from './AdminFormInput';
import ImagePicker from '@/components/ImagePicker';
import type { TemplateConfig } from '@/mocks/template-config';

interface TopFormProps {
  config: TemplateConfig['top'];
  onChange: (config: TemplateConfig['top']) => void;
}

export default function TopForm({ config, onChange }: TopFormProps) {
  const update = <K extends keyof TemplateConfig['top']>(key: K, value: TemplateConfig['top'][K]) => {
    onChange({ ...config, [key]: value });
  };

  return (
    <div className="space-y-5">
      <AdminSectionCard title="Configuração do Topo" icon="ri-layout-top-line">
        <AdminSelect
          label="Modo do Topo"
          value={config.mode}
          onChange={(e) => update('mode', e.target.value as 'banner_full' | 'banner_background')}
          options={[
            { value: 'banner_full', label: 'Banner Completo' },
            { value: 'banner_background', label: 'Banner com Textos' },
          ]}
        />
        <ImagePicker
          label="Imagem / Banner"
          value={config.bannerImage}
          onChange={(url) => update('bannerImage', url)}
          type="template"
          category="top-banner"
        />
        <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
          <AdminInput
            label="Título"
            value={config.title}
            onChange={(e) => update('title', e.target.value)}
          />
          <AdminInput
            label="Subtítulo"
            value={config.subtitle}
            onChange={(e) => update('subtitle', e.target.value)}
          />
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
          <AdminSelect
            label="Overlay"
            value={config.overlay}
            onChange={(e) => update('overlay', e.target.value as 'dark' | 'light' | 'none')}
            options={[
              { value: 'dark', label: 'Escuro' },
              { value: 'light', label: 'Claro' },
              { value: 'none', label: 'Nenhum' },
            ]}
          />
          <AdminSelect
            label="Alinhamento"
            value={config.alignment}
            onChange={(e) => update('alignment', e.target.value as 'center' | 'left')}
            options={[
              { value: 'center', label: 'Centralizado' },
              { value: 'left', label: 'Esquerda' },
            ]}
          />
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-3 gap-4 pt-2">
          <AdminToggle
            label="Mostrar Logo"
            checked={config.showLogo}
            onChange={(v) => update('showLogo', v)}
          />
          <AdminToggle
            label="Mostrar Empresa"
            checked={config.showCompanyName}
            onChange={(v) => update('showCompanyName', v)}
          />
          <AdminToggle
            label="Mostrar 'Desde'"
            checked={config.showFounded}
            onChange={(v) => update('showFounded', v)}
          />
          <AdminToggle
            label="Mostrar Título"
            checked={config.showTitle}
            onChange={(v) => update('showTitle', v)}
          />
          <AdminToggle
            label="Mostrar Subtítulo"
            checked={config.showSubtitle}
            onChange={(v) => update('showSubtitle', v)}
          />
        </div>
      </AdminSectionCard>
    </div>
  );
}